import request from '@/utils/request'

let BillApi = {

  /*发票列表*/
  list(data) {
    return request._post('/shop/plus.bill.Index/index', data);
},
/*添加发票*/
add(data) {
    return request._post('/shop/plus.bill.Index/add', data);
},
/*修改发票*/
edit(data) {
    return request._post('/shop/plus.bill.Index/edit', data);
},
/*删除发票*/
del(data) {
    return request._post('/shop/plus.bill.Index/del', data);
},
/*发票详情*/
detail(data) {
  return request._post('/shop/plus.bill.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.bill.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.bill.Setting/getSetting', data, errorback);
    },/*发票申请-通过*/
    pass(data) {
      return request._post('/shop/plus.bill.Index/pass', data);
    },
    /*发票申请-不通过*/
    nopass(data) {
      return request._post('/shop/plus.bill.Index/nopass', data);
    },
        /*去发货*/
        delivery(data) {
          return request._post('/shop/plus.bill.Index/delivery', data);
      },
    
}
export default BillApi;



// WEBPACK FOOTER //
// ./src/api/bill.js